<template>
    <div
        :class="[
            {
                'open': accordionOpen,
            },
            'accordion-item',
        ]"
    >
        <button
            @click="toggleAccordion"
            :ref="id"
            class="accordion-header d-block"
        >
            <h3 class="accordion-title">
                <span v-html="title" />
                <span
                    v-if="subtitle"
                    class="accordion-subtitle hidden-until-md"
                >
                    {{ subtitle }}
                </span>
                <icon
                    icon="arrow-right"
                />
            </h3>
        </button>
        <div
            class="accordion-inner"
        >
            <slot />
        </div>
    </div>
</template>

<script>
    import Icon from '@/components/icon';

    export default {
        name: 'Accordion',
        components: {
            Icon,
        },
        data() {
            return {
                accordionOpen: false,
            };
        },
        props: {
            title: {
                required: true,
                type: String,
            },
            subtitle: {
                required: false,
                type: String,
            },
            id: {
                required: false,
                type: Number,
            },
        },
        methods: {
            toggleAccordion() {
                this.accordionOpen = !this.accordionOpen;
            },
        },
    };
</script>

<style lang="scss">
    .accordion {
        &-item {
            width: 100%;
            margin-bottom: 16px;
            background-color: #fff;
            border: 1px solid #fff;
            border-radius: 3px;
            transition: border-color 0.3s;

            &:last-of-type {
                margin-bottom: 35px;
            }

            &:hover {
                border-color: $blaze-orange;
            }

            &.open {
                border-color: $blaze-orange;
            }
        }

        &-inner {
            display: none;
            font-size: 14px;

            .open & {
                display: block;
                padding: 0 24px 24px;
            }
        }

        &-header {
            width: 100%;
            padding: 24px;
            cursor: pointer;
        }

        &-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 0;
            font-family: $font-body;
            font-size: 16px;
            font-weight: 700;
            line-height: 16px;
            color: $blaze-orange;

            .icon {
                font-size: 18px;
                color: $blaze-orange;
                transition: transform 0.3s;
                transform: rotate(90deg);

                .open & {
                    transform: rotate(90deg) scale(-1);
                }
            }
        }

        &-subtitle {
            margin: 0 16px 0 auto;
            font-size: 12px;
            color: $cape-cod;
        }

        &-text {
            font-size: 14px;
            line-height: 26px;
        }
    }
</style>
